export class RejectedApplicantError extends Error {}
